import React, { useState, useRef, useEffect } from 'react';
import DatePicker from 'react-date-picker'
import TooltipWithTimer from '../../tooltip/TooltipWithTimer';
import Select from 'react-select';

import './UserCreateMain.css';

const InputText = React.memo(props=>{
  return(
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
    />
  )
})

const UserCreateMain = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const tooltipTarget = useRef(null);

  useEffect(() => {
    const timerId = setInterval(() => {
      if(tooltipShow) setTooltipShow(false);
    }, 3000);
    return ()=>clearInterval(timerId);
  }, [tooltipShow])


  return (
    <div className="UserCreateContainer">
      <table className="UserCreateTable" width="100%">
        <tr>
          <td align="right" style={{width: "120px"}}>
            <span className="UserCreateTit">Email</span>
          </td>
          <td>
            <InputText onChange={props.handleEmail} value={props.email} name="email-textfield" type="text" className="box" id="textfield1" size="25" />
          </td>
        </tr>
        <tr>
          <td align="right" tyle={{width: "120px"}}>
            <span className="UserCreateTit">이름</span>
          </td>
          <td>
            <InputText onChange={props.handleUsername} value={props.username} name="name-textfield" type="text" className="box" id="textfield1" size="25" />
          </td>
        </tr>
        <tr>
          <td align="right" style={{width: "120px"}}>
            <span className="UserCreateTit">패스워드</span>
          </td>
          <td>
            <InputText onChange={props.handleNewPassword} value={props.newPassword} name="newpasswordfield" type="password" className="box" id="textfield3" size="25" />
            <span className="condition-tooltip">8자 이상을 입력해주세요.</span>
          </td>
        </tr>
        <tr>
          <td align="right" style={{width: "120px"}}>
            <span className="UserCreateTit">패스워드 확인</span>
          </td>
          <td>
            <InputText onChange={props.handleConfirmPassword} value={props.confirmPassword} name="confirmpasswordfield" type="password" className="box" id="textfield4" size="25" />
            {props.newPassword==props.confirmPassword ? <></>:<span className="validation-tooltip">일치하지 않습니다.</span>}
          </td>
        </tr>
        <tr>
          <td align="right" style={{width: "120px"}}>
            <span className="UserCreateTit">권한</span>
          </td>
          <td>
            <Select isClearable={false} isSearchable={false} defaultValue={props.defaultRole} options={props.roleSelectOption}
              onChange={(e)=>{
                props.selectRole(e)
              }}
              styles={{
                container: base => ({
                  ...base,
                  width: "180px",
                  marginTop: "-6px"
                }),
                option: base => ({
                  ...base,
                  textAlign: "left"
                })
              }}
            />
          </td>
        </tr>
        <tr>
          <td align="right" stye={{width: "120px"}}>
            <span className="UserCreateTit">Expired Date</span>
          </td>
          <td>
            <DatePicker onChange={props.handleDate} value={props.expireDate}
              minDetail="decade" format="y-MM-dd" clearIcon={null} />
          </td>
        </tr>
        <tr>
          <td align="right" stye={{width: "120px"}}>
              <span className="UserCreateTit">Company</span>
          </td>
          <td>
            <InputText onChange={props.handleCompany} value={props.company} name="companyfield" type="text" className="box" id="textfield3" size="25" />
          </td>
        </tr>
      </table>
      <div className="user-create-save-box">
        <a className="button purple_line"  ref={tooltipTarget} onClick={()=>{props.handleCreate(); setTooltipShow(true)}}>생성</a>
        <TooltipWithTimer target={tooltipTarget} show={tooltipShow} tooltipDirection="top" tooltipText={props.saveTooltip} />
      </div>
    </div>
  )
}

export default UserCreateMain;